import form from './form.en';
import table from './table.en';
import fileForm from './fileForm.en';
import folderForm from './folderForm.en';
import uploadFormPopup from './uploadFormPopup.en';
export default {
    table,
    folderForm,
    uploadFormPopup,
    fileForm,
    form,
    breadcrumb: 'Repository',
};
